// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TeamChatBot-Main-Container{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 50vh;
  
}
.Chatbot-devploment{
    color: #061522;
text-align: center;
font-size: 18px;
font-style: normal;
font-weight: 500;
line-height: 18px; /* 100% */
margin-top: 39px;
}
.Chatbot-crafting{
    color: #405261;
text-align: center;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 18px; /* 128.571% */
margin-top: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboardcomponents/ChatBot/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;;AAEhB;AACA;IACI,cAAc;AAClB,kBAAkB;AAClB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB,EAAE,SAAS;AAC5B,gBAAgB;AAChB;AACA;IACI,cAAc;AAClB,kBAAkB;AAClB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB,EAAE,aAAa;AAChC,eAAe;AACf","sourcesContent":[".TeamChatBot-Main-Container{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 50vh;\n  \n}\n.Chatbot-devploment{\n    color: #061522;\ntext-align: center;\nfont-size: 18px;\nfont-style: normal;\nfont-weight: 500;\nline-height: 18px; /* 100% */\nmargin-top: 39px;\n}\n.Chatbot-crafting{\n    color: #405261;\ntext-align: center;\nfont-size: 14px;\nfont-style: normal;\nfont-weight: 400;\nline-height: 18px; /* 128.571% */\nmargin-top: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
